import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LxlibUtilModule } from '@lxlib/util';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ErrorCollectComponent } from './error-collect.component';

const COMPONENTS = [ErrorCollectComponent];

@NgModule({
  imports: [CommonModule, LxlibUtilModule, NzIconModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class ErrorCollectModule {}
